import Dispatcher from "./dispatcher";

var Analytics = {};

Analytics.init = function () {};

Analytics.gaEvent = function (category, label, action) {
  Analytics.noticeInteraction(category, {label, action})
};

// Insights below:

// noticeInteraction targets new relic, when all vestigial gaEvents
// are switched over then the GA side of Analytics can be removed

Analytics.noticeInteraction = function(id, params = {}) {

  if (typeof params !== "object") {
    throw Error("extra params must be type object");
  }
  if (window.newrelic) {
    window.newrelic.addPageAction(id, params);
  } else {
    // log is useful for local testing, log should not appear when deployed
    // eslint-disable-next-line no-console
    console.log(`noticeInteraction: ${id} ${JSON.stringify(params)}`);
  }
}

Analytics.noticeError = function(e) {
  // eslint-disable-next-line no-console
  console.error(e);
  let errorToLog = e;
  if (typeof e === "string") {
    errorToLog = new Error(e);
  }

  if (window.newrelic) {
    // Must throw to ensure stack traces in all browsers in all situations
    // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/noticeerror-browser-agent-api/#browser-limits
    try {
      throw errorToLog;
    } catch (err) {
      window.newrelic.noticeError(err);
    }
  }
}

Analytics.startFlow = function (name) {};

Analytics.stopFlow = function (guid) {};

Analytics.addFlows = function (analyticsObject) {};

Analytics.addEvent = function (name) {};

Analytics.flushEvents = function () {};

// tough one since this technically isn't a jsx file
Analytics.generalFeedback = function (force) {
  if (!Fraction.Helpers.getItem("modalShown") || force) {
    Dispatcher.emit(Dispatcher.OPEN_MODAL, "give-feedback");
  }
  Fraction.Helpers.setItem("modalShown", true);
};

// Interaction monitoring adapted from Supernova
// https://github.com/vitalsource/supernova/blob/main/src/main/useInteractionMonitoring.ts
function setupInteractionMonitoring() {
  const handleClick = (e) => {
    const el = e.target.closest("a,button");
    if (el) {
      const interactionId = el.getAttribute("data-interaction-id");
      if (interactionId) {
        const params = {};
        Array.from(el.attributes).forEach((attr) => {
          const prefix = "data-interaction-param-";
          if (attr.name.indexOf(prefix) === 0) {
            const paramName = attr.name.substr(prefix.length);
            params[paramName] = attr.value;
          }
        });
        Analytics.noticeInteraction(interactionId, params);
      }
    }
  }

  // useCapture to read attribute values before react updates them
  window.addEventListener("click", handleClick, true);
}
setupInteractionMonitoring();

export default Analytics;
